import { RELAY_SOL_ADDRESS, RELAY_SOLANA_MAINNET_CHAIN_ID, ZERO_ADDRESS } from "../../anyspend/constants/index.js";
import { avalanche, bsc, polygon } from "viem/chains";
export const HYPERLIQUID_CHAIN_ID = 1337;
export const HYPEREVM_CHAIN_ID = 999;
export const PLUME_CHAIN_ID = 98866;
/**
 * Hyperliquid uses a special 34-character USDC address format (0x + 32 hex digits)
 * instead of the standard 42-character EVM address format.
 * This is required by Relay SDK for Hyperliquid integration.
 */
export const HYPERLIQUID_USDC_ADDRESS = "0x00000000000000000000000000000000";
export function isNativeToken(address) {
    return address.toLowerCase() === ZERO_ADDRESS || address.toLowerCase() === RELAY_SOL_ADDRESS;
}
export function getSolanaToken() {
    return {
        chainId: RELAY_SOLANA_MAINNET_CHAIN_ID,
        address: RELAY_SOL_ADDRESS,
        symbol: "SOL",
        name: "Solana",
        decimals: 9,
        metadata: {
            logoURI: "https://assets.relay.link/icons/square/792703809/light.png",
        },
    };
}
export function getEthToken(chainId) {
    return {
        chainId: chainId,
        address: ZERO_ADDRESS,
        symbol: "ETH",
        name: "Ethereum",
        decimals: 18,
        metadata: {
            logoURI: "https://assets.relay.link/icons/square/1/light.png",
        },
    };
}
export function getPolToken() {
    return {
        chainId: polygon.id,
        address: ZERO_ADDRESS,
        symbol: "POL",
        name: "Polygon",
        decimals: 18,
        metadata: {
            logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/28321.png",
        },
    };
}
export function getBnbToken() {
    return {
        chainId: bsc.id,
        address: ZERO_ADDRESS,
        symbol: "BNB",
        name: "BNB",
        decimals: 18,
        metadata: {
            logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png",
        },
    };
}
export function getAvaxToken() {
    return {
        chainId: avalanche.id,
        address: ZERO_ADDRESS,
        symbol: "AVAX",
        name: "AVAX",
        decimals: 18,
        metadata: {
            logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png",
        },
    };
}
export function getHyperEVMNativeToken() {
    return {
        chainId: HYPEREVM_CHAIN_ID,
        address: ZERO_ADDRESS,
        symbol: "HYPE",
        name: "HYPE",
        decimals: 18,
        metadata: {
            logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/32196.png",
        },
    };
}
export function getHyperliquidUSDCToken() {
    return {
        chainId: HYPERLIQUID_CHAIN_ID,
        address: HYPERLIQUID_USDC_ADDRESS,
        symbol: "USDC",
        name: "USD Coin",
        decimals: 8, // Hyperliquid USDC uses 8 decimals, not 6
        metadata: {
            logoURI: "https://ethereum-optimism.github.io/data/USDC/logo.png",
        },
    };
}
export function getPlumeNativeToken() {
    return {
        chainId: PLUME_CHAIN_ID,
        address: ZERO_ADDRESS,
        symbol: "PLUME",
        name: "Plume",
        decimals: 18,
        metadata: {
            logoURI: "https://cdn.b3.fun/b3os-icons/plume.svg",
        },
    };
}
